import React from 'react';
import { Section } from 'common/components/items-menu/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
export function OverflowControls(props: {
  items: Section[];
  onMenuChange?: (isOpen?: boolean) => void;
}) {
  return <SelectReact neverShowCaret iconOnly experimentalPositioning theme={SelectTheme.Tertiary} sections={props.items} menuWidth={-1} // adjusts the menu width to hug content
  menuHeight={-1} icon={{
    leftIcon: "ellipsis"
  }} onMenuChange={ev => {
    var _props$onMenuChange;
    return (_props$onMenuChange = props.onMenuChange) === null || _props$onMenuChange === void 0 ? void 0 : _props$onMenuChange.call(props, ev.detail.isOpen);
  }} data-sentry-element="SelectReact" data-sentry-component="OverflowControls" data-sentry-source-file="controls.tsx" />;
}